
<div>
  <h5 translate>m2.sprint3.cockpit.card.funktionswert.diagramm</h5>
  <div id="svgChartKoeffKonfidenzintervalle" style="padding-bottom: 50px;" class="pdt-30 width-max-100-perc"></div>
</div>
